"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WindowPoll = void 0;
const OPENED_WINDOW_POLLING_TIME = 100;
class WindowPoll {
    constructor(openedWindow, cleanupCallback) {
        this.start = () => {
            // SetInterval is used for checking if the pop up is closed or not
            // as there is no better way to check if pop up window is closed or not
            // remove overlay when the opened window is closed
            this.openedWindowPolling = setInterval(() => {
                if (this.window.closed) {
                    this.cleanupCallback();
                    // stop the polling if the opened window is closed
                    clearInterval(this.openedWindowPolling);
                }
            }, OPENED_WINDOW_POLLING_TIME);
        };
        this.window = openedWindow;
        this.cleanupCallback = cleanupCallback;
    }
}
exports.WindowPoll = WindowPoll;
